/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetNextBestActionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/next_best_action_messages.pb'
import {GetNextBestActionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/next_best_action_messages.pb'


export const getNextBestAction = (request: GetNextBestActionRequest, options?: CashRequestOptions) => post<GetNextBestActionRequest, GetNextBestActionResponse>("/cash-app/goose-cash/v3/get-next-best-action", request, {...options, rejectOnError: true })